// Storyblok content links to the live app (signup buttons, Log in, plan cards).
// On a test environment XOLO_SELFSERVICE_URL names that environment's app, so
// those links are pointed there instead, as the legacy www did with its
// per-environment config. Done on the fetched story, so client components and
// rich text get the rewritten links too.

const LIVE_APP = 'https://app.xolo.io';

/** This environment's app: XOLO_SELFSERVICE_URL, or the live app when unset. */
export const APP_URL = process.env.XOLO_SELFSERVICE_URL?.replace(/\/+$/, '') || LIVE_APP;

// Only the bare host or a path, query or fragment after it, so a look-alike
// host such as https://app.xolo.io.example.com is left alone.
const LIVE_APP_URL = /^https:\/\/app\.xolo\.io(?=[/?#]|$)/;

function rewrite(value, appUrl) {
  if (typeof value === 'string') return value.replace(LIVE_APP_URL, appUrl);
  if (Array.isArray(value)) return value.map((item) => rewrite(item, appUrl));
  if (value && typeof value === 'object') {
    return Object.fromEntries(Object.entries(value).map(([key, item]) => [key, rewrite(item, appUrl)]));
  }
  return value;
}

/** The story with every live-app link pointed at this environment's app. */
export function pointAppLinksAtEnvironment(story, appUrl = APP_URL) {
  if (!story || appUrl === LIVE_APP) return story;
  return rewrite(story, appUrl);
}
